export default __webpack_public_path__ + "static/media/globe-solid.e54d5db5.svg";